import { tempoApi } from '../tempoApi';

type UpdateItemRankBody = {
  previousItemId?: number;
  nextItemId?: number;
};

type ItemRankEntry = {
  itemId: number;
  rank: string;
};

const getItemRanks = async (viewId: number, visualizationId: number): Promise<ItemRankEntry[]> => {
  return tempoApi()
    .get(`api/v1/roadmap/view/${viewId}/visualization/${visualizationId}/itemRanks`)
    .json<ItemRankEntry[]>();
};

const updateItemRank = async (
  viewId: number,
  visualizationId: number,
  itemId: number,
  body: UpdateItemRankBody,
): Promise<void> => {
  await tempoApi().put(
    `api/v1/roadmap/view/${viewId}/visualization/${visualizationId}/itemRanks/${itemId}`,
    {
      json: body,
    },
  );
};

const initializeRanks = async (
  viewId: number,
  visualizationId: number,
  itemIds: number[],
): Promise<void> => {
  await tempoApi().post(
    `api/v1/roadmap/view/${viewId}/visualization/${visualizationId}/itemRanks/initialize`,
    {
      json: { itemIds },
    },
  );
};

export const VisualizationRanksApi = {
  getItemRanks,
  updateItemRank,
  initializeRanks,
} as const;
